// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"uU-z","categoryName":"vU-z","categoryImage":"wU-z","categoryContent":"xU-z","bottomAligned":"yU-z"};